/**
 * Browser-local mode: running in a browser connected to a local Tauri process via HTTP.
 * Uses browser APIs for platform operations (clipboard, download, etc.)
 * but reports as 'tauri' platform so the app shows the full desktop UI.
 */
import { BrowserPlatformUtil } from './browser-platform-util'

import type * as PlatformUtil from './platform-util'

export const BrowserLocalPlatformUtil: PlatformUtil.PlatformUtil = {
  ...BrowserPlatformUtil,
  platform: 'browser-local' as const,
  is: (platform) => platform === 'browser-local',
  locale: async () => navigator.language,
  hostPlatform: () => undefined,
}
